/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { RequestCache } from '@msdyn365-commerce/cache-internal';
import { IActionContext } from '@msdyn365-commerce/core-internal';
import { ActionContext } from './action-context';

/**
 * Creates a mock but usable ActionContext.
 * @param context The partial context to add to the return action context.
 *
 * DEPRECATED: Please use buildMockActionContext and pass in a constructed
 * ActionContext to build a hydrated mock action context
 * Example:
 *      const actionContext = buildMockActionContext(new ActionContext({
 *           id: 'mock-context',
 *           requestCache: new RequestCache(),
 *           requestContext: {},
 *           appCache: null
 *       }));
 *
 */
export const buildHydratedMockActionContext = (context?: Partial<IActionContext>): IActionContext => {
    return new ActionContext({
        id: 'mock-context',
        requestCache: new RequestCache(),
        requestContext: (context && context.requestContext) || {},
        appCache: null
    });
};
